import React from 'react';

import PropTypes from 'prop-types';

import Confirm from 'components/Confirm';
import Message from 'components/Message';
import appMessages from 'features/App/App.messages';

import messages from './SkuMissedPickupModal.messages';

export const SKU_MISSED_PICKUP_MODAL_NAME = 'SkuMissedPickupModal';

const SkuMissedPickupModal = ({ onConfirm, onCancel }) => (
  <Confirm
    title={<Message message={messages.title} />}
    hasCloseButton
    onCancel={onCancel}
    cancelNode={<Message message={appMessages.cancel} />}
    acceptNode={<Message message={messages.confirm} />}
    onConfirm={onConfirm}>
    <Message message={messages.body} />
  </Confirm>
);

SkuMissedPickupModal.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default SkuMissedPickupModal;
